export const pageurl = {
	LOGIN: '/',
	VERIFYOTP: '/verify-otp',
	MYELECTION: '/admin/my-election',
	LIVEELECTION: '/admin/live-election',
	STRONGHOLD: '/admin/strong-hold',
	CANCELLED_UNITS: '/admin/cancelled-units',
	MYPARTY: '/admin/my-party',
	PROFILE: '/admin/view-profile',
	SETTINGS: '/admin/settings',
	OVERVIEW: '/admin/overview',
	ORGANIZATIONS: '/admin/organizations',
	ELECTORALDIVISIONS: '/admin/electoral-divisions',
	CONSTITUENCY: '/admin/electoral-divisions/constituency',
	CONSTITUENCY_REPORT: '/admin/electoral-divisions/constituency/report',
	POLLINGUNITS: '/admin/electoral-divisions/polling-units',
	/** `${POLLINGUNITS}/:code` — one polling unit's full page. The code is URI-encoded. */
	POLLINGUNIT_DETAIL: '/admin/electoral-divisions/polling-units/:code',
	ZONES: '/admin/electoral-divisions/zones',
	STATES: '/admin/electoral-divisions/states',
	LGAS: '/admin/electoral-divisions/lgas',
	WARDS: '/admin/electoral-divisions/wards',
	TREE: '/admin/electoral-divisions/tree',
	ELECTIONS: '/admin/elections',
	PRESIDINGOFFICER: '/admin/presiding-officers',
	MANAGEMENT: '/admin/management',
	USERS: '/admin/management/users',
	REPORT: '/admin/management/reports',
	ROLEACTIONS: '/admin/management/role-actions',
	ROLES: '/admin/management/roles',
	ROLES_MATRIX: '/admin/management/roles/matrix',
	API_KEYS: '/admin/management/api-keys',
	API_KEYS_DOCS: '/admin/management/api-keys/docs',
	SERVICE_REGISTRY: '/admin/management/service-registry',
	TEAM_ACCESS: '/admin/management/team-access',
	NOTIFICATIONS: '/admin/management/app-notifications',
	REQUESTLIST: '/admin/management/request-list',
	AUDITTRAIL: '/admin/management/audit-trail',
	RESULTNOTIFICATIONS: '/admin/management/result-notifications',
	ELECTIONOFFICIALS: '/admin/management/election-officials',
	POLITICALPARTY: '/admin/political-party',
	RESULTS: '/admin/election-results',
	RESULTANALYTICS: '/admin/result-analytics',
	RESULTANALYTICS_ALL_LEVELS: '/admin/result-analytics/all-levels',
	RESULTANALYTICS_BY_LEVEL: '/admin/result-analytics/level',
	RESULTANALYTICS_BY_GEOGRAPHY: '/admin/result-analytics/geography',
	RESULTANALYTICS_LEGACY: '/admin/elections/analytics',
	RESULTVERIFICATION: '/admin/result-verification',
	RESULTVERIFICATION_DETAIL: '/admin/result-verification/detail',
	RESULTVERIFICATION_DISPUTES: '/admin/result-verification/disputes',
	RESULTAUDIT: '/admin/result-audit',
	RESULTAUDIT_ENTITY: '/admin/result-audit/entity',
	RESULTTIMEMACHINE: '/admin/result-time-machine',
	IREVEXTRACTION: '/admin/irev-extraction',
	RESULTPIPELINE: '/admin/result-pipeline',
	// Deliberately a top-level path, NOT nested under /admin/result-analytics. Route policies
	// resolve by longest prefix, so a nested path would inherit `election_result_analytics` —
	// which Party Admins and Candidates hold. A page naming individual analysts and their
	// overturn rates must not be reachable that way.
	ANALYSTPERFORMANCE: '/admin/analyst-performance',
	AI: '/admin/ai-result-extraction',
	ELECTIONPARAMETERS: '/admin/election-parameters',
	ELECTIONTYPE: '/admin/election-parameters/election-type',
	ELECTIONCYCLE: '/admin/election-parameters/election-attribute',
	ELECTIVECATEGORY: '/admin/election-parameters/elective-category',
	PARTY_PARTICIPATION: '/admin/election-parameters/party-participation',
	SUPPORT: '/admin/support',
	MANAGEAGENTS: '/admin/elections/manage-agents',
	MANAGEAGENTSDASHBOARD: '/admin/elections/manage-agents/dashboard',
	MANAGEAGENTS_LIVEMAP: '/admin/elections/manage-agents/live-map',
	MANAGEAGENTS_COVERAGE: '/admin/elections/manage-agents/coverage',
	VESR: '/admin/vesr',
	VESR_DASHBOARD: '/admin/vesr',
	VESR_INCIDENTS: '/admin/vesr/incidents',
	VESR_INCIDENT_CREATE: '/admin/vesr/incidents/create',
	VESR_ELECTION_PULSE: '/admin/vesr/election-pulse',
	VESR_COMMUNICATION: '/admin/vesr/communication',
	VESR_MEETINGS: '/admin/vesr/communication/meetings',
	VESR_MEDIA: '/admin/vesr/media',
	VESR_INTEGRATION: '/admin/vesr/integration',
	VESR_EFLOC: '/admin/vesr/integration/efloc',
	VESR_USERS: '/admin/vesr/users',
	VESR_REPORTS: '/admin/vesr/reports',
	VESR_FEEDBACK: '/admin/vesr/feedback',
	VESR_ACTIVITIES: '/admin/vesr/activities',
	VESR_ANALYTICS: '/admin/vesr/analytics',
	VESR_AUDIT_LOGS: '/admin/vesr/audit-logs',
	// Legacy address of the Import Voters page — now a redirect into the Voters workspace.
	IMPORTVOTERS: '/admin/import-voters',
	// Voters workspace: Register (index) · Import · Import history. Nested routes live in
	// src/app/voters/index.tsx, so children inherit this policy by prefix.
	VOTERS: '/admin/voters',
	VOTERS_IMPORT: '/admin/voters/import',
	VOTERS_HISTORY: '/admin/voters/history',
	// INEC candidate registry (everyone who contested, any year). Top-level for the longest-prefix
	// reason above; the layout in src/app/candidate-records/index.tsx owns index / import / seat / trail.
	CANDIDATE_RECORDS: '/admin/candidate-records',
	CANDIDATE_RECORDS_IMPORT: '/admin/candidate-records/import',
	CANDIDATE_RECORDS_SEAT: '/admin/candidate-records/seat',
	CANDIDATE_RECORDS_TRAIL: '/admin/candidate-records/trail',
	MYWALLET: '/admin/my-wallet',
	MY_TEAM: '/admin/my-team',
	SERVICE_RATE: '/admin/management/service-rates',
	COUPON: '/admin/management/coupons',
	VOTER_INTERACTIONS: '/admin/voter-interactions',
	// Contacts is a SIBLING of Voter Interactions, not a child: it is scoped by the JWT UserId, not
	// by election, so nesting it would inherit `requiresElection` and hide it with no election picked.
	CONTACTS: '/admin/contacts',
	// Literal segments must be declared BEFORE the `:listId` route in src/app/contacts/index.tsx, or
	// they are captured as a list id.
	CONTACTS_IMPORT: '/admin/contacts/import',
	CONTACTS_DUPLICATES: '/admin/contacts/duplicates',
	// Top-level on purpose. Route policies resolve by LONGEST PREFIX (src/authz/route-policy.ts),
	// so nesting this under /admin/voter-interactions would silently inherit that module's gate.
	// Scoped by (partyId, candidateId), never by election — hence no `requiresElection`, same
	// reasoning as CONTACTS above.
	MEDIA_GALLERY: '/admin/media-gallery',
	// Top-level for the same longest-prefix reason. Templates are per USER, never per election.
	MESSAGE_TEMPLATES: '/admin/message-templates',
	ELECTIONS_DASHBOARD: '/admin/elections/dashboard',
	MANAGEMENT_DASHBOARD: '/admin/management/dashboard',
	FEEDBACK: '/admin/management/feedback',
	LEGAL_DOCUMENT_TYPES: '/admin/management/document-types',
	LEGAL_DOCUMENTS: '/admin/management/legal-documents',
	LEGAL_CONSENTS: '/admin/management/legal-consents',
	CHANNEL_GOVERNANCE: '/admin/management/channel-governance',
	// Course detail / module editors will nest under this, inheriting its gate by longest prefix.
	LMS_COURSES: '/admin/management/academy-courses',
	ADMIN_WALLETS: '/admin/management/wallets',
	ELECTIONOBSERVER: '/admin/election-observer',
	MANAGE_OBSERVERS: '/admin/election-observer/manage',
	// Under MANAGE_OBSERVERS on purpose: it inherits that gate (election_observers_manage) by longest
	// prefix, so an Observer Admin reaches it with no new permission key and no re-login.
	OBSERVER_LIVEMAP: '/admin/election-observer/manage/live-map',
	// Top-level for the longest-prefix reason above: an Observer Admin's home must not inherit
	// the Election Observer partner list's gate.
	OBSERVER_DASHBOARD: '/admin/observer-dashboard',
	OBSERVER_DESK: '/admin/observer-desk',
	// Help Centre. `search` and `manage` are literal segments, so they are reserved slugs: the
	// editor refuses them and react-router ranks a static segment above `:slug`.
	HELP: '/admin/help',
	HELP_SEARCH: '/admin/help/search',
	HELP_MANAGE: '/admin/help/manage',
};
